import { buildUri } from "../../utils/dom";

export class AppointmentTypeService {
    
    #appointmentTypes = [];
    
    get uri() {
       return buildUri(v24Scheduler.serviceRegion,`/api/scheduler/AppointmentTypes`);
    }

    get appointmentTypes() {
        return this.#appointmentTypes;
    }

    async getAppointmentTypes(sitename) {
        const params = new URLSearchParams();
        
        if (!sitename) {
            throw new Error("sitename not defined");
        }
        
        params.append("sitename", sitename);
        const uri = `${this.uri}?${params.toString()}`;

        this.#appointmentTypes = 
            await fetch(uri)
            .then((response) =>response.json())
            .then((data) => data.appointmentTypes);
    }

    static FindAppointmentTypeById(appointmentTypes, appointmentTypeId) {
        return appointmentTypes.find((type) => type.id === parseInt(appointmentTypeId));
    }

    static FindAppointmentTypeByName(appointmentTypes, name) {
        return appointmentTypes.find((type) => type.name === name);
    }

    static FilterAppointmentsByLocation(appointmentTypes, locationId){

        let filteredAptTypes = appointmentTypes.filter((type) => locationId === -1 ? type.locationIds.length === 0 : type.locationIds.includes(locationId));

        if(filteredAptTypes.length === 0){

            console.warn(`No appointment types found with location id ${locationId}, returning all appointment types`);

            return appointmentTypes;
        }

        return filteredAptTypes;

    }
}
